<template>
    <TransitionRoot
        as="template"
        :show="menuOpen === true"
    >
        <Dialog
            as="div"
            class="relative z-[5700] select-none lg:hidden"
            @close="menuOpen = false"
        >
            <TransitionChild
                as="template"
                enter="transition-opacity ease-linear duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="transition-opacity ease-linear duration-300"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 z-1 bg-slate-900/85" />
            </TransitionChild>

            <div class="fixed inset-0 z-40 flex">
                <TransitionChild
                    as="template"
                    enter="transition ease-in-out duration-300 transform"
                    enter-from="-translate-x-full"
                    enter-to="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leave-from="translate-x-0"
                    leave-to="-translate-x-full"
                >
                    <DialogPanel class="relative flex w-full max-w-xs flex-1 flex-col bg-slate-900">
                        <TransitionChild
                            as="template"
                            enter="ease-in-out duration-300"
                            enter-from="opacity-0"
                            enter-to="opacity-100"
                            leave="ease-in-out duration-300"
                            leave-from="opacity-100"
                            leave-to="opacity-0"
                        >
                            <div class="absolute top-0 right-0 -mr-12 pt-1">
                                <button
                                    type="button"
                                    class="ml-1 flex h-10 w-10 cursor-pointer items-center justify-center focus:ring-0 focus:outline-hidden"
                                    @click="menuOpen = false"
                                >
                                    <span class="sr-only">Close sidebar</span>
                                    <MdiClose
                                        class="block h-8 w-8 text-slate-200"
                                        aria-hidden="true"
                                    />
                                </button>
                            </div>
                        </TransitionChild>
                        <div
                            id="msn"
                            class="h-0 flex-1 overflow-y-auto bg-slate-700 pt-0 pb-4"
                        >
                            <nav
                                v-if="loggedUser.id !== '0'"
                                class="p-0"
                                aria-label="nav"
                                aria-labelledby="msn"
                            >
                                <a
                                    v-for="item in navigation.main"
                                    :key="item.name"
                                    :href="item.href"
                                    :class="[
                                        currentRouteMatch(item.matchRoutes, route.name)
                                            ? 'bg-slate-900 text-slate-100'
                                            : 'text-slate-200 hover:bg-slate-600 hover:text-slate-200',
                                        'group flex h-12 items-center p-3 text-sm font-medium transition-colors',
                                    ]"
                                >
                                    <component
                                        :is="item.icon"
                                        class="h-5 w-5 shrink-0"
                                        aria-hidden="true"
                                    />
                                    <div class="ml-3 text-sm font-medium">
                                        {{ item.title }}
                                    </div>
                                </a>
                            </nav>
                        </div>

                        <div
                            v-if="loggedUser.id !== '0'"
                            class="flex shrink-0 flex-col bg-slate-900 p-0"
                        >
                            <a
                                v-for="item in navigation.user"
                                :key="item.name"
                                :href="item.href"
                                :class="[
                                    currentRouteMatch(item.matchRoutes, route.name)
                                        ? 'bg-slate-900 text-slate-100'
                                        : 'text-slate-200 hover:bg-slate-900 hover:text-slate-100',
                                    'group flex items-center p-3 text-sm font-medium transition-colors',
                                ]"
                            >
                                <component
                                    :is="item.icon"
                                    class="h-5 w-5 shrink-0"
                                    aria-hidden="true"
                                />
                                <div class="ml-3 text-sm font-medium">
                                    {{ item.title }}
                                </div>
                            </a>

                            <button
                                class="group block w-full shrink-0 cursor-pointer"
                                @click="logoutSession()"
                            >
                                <div
                                    class="flex items-center p-3 text-amber-400 transition-colors group-hover:bg-slate-900 group-hover:text-amber-200"
                                >
                                    <MdiLogout
                                        class="block h-5 w-5"
                                        aria-hidden="true"
                                    />
                                    <div class="ml-3 text-sm font-medium">
                                        {{ t('Logout') }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </DialogPanel>
                </TransitionChild>
                <div class="w-14 shrink-0">
                    <!-- Force sidebar to shrink to fit close icon -->
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <div
        v-if="loggedUser.id !== '0'"
        class="fixed top-0 z-[5699] flex h-12 w-full items-center justify-between bg-slate-900 pl-3 select-none sm:pl-3 lg:hidden lg:pt-3"
    >
        <router-link
            :to="{ name: 'dashboard' }"
            class="inline-flex h-10 w-28 flex-col items-start justify-center bg-slate-900"
        >
            <BrandLogo css-class="w-40" />
            <!-- <span class="text-slate-200 text-xs font-bold uppercase tracking-wide">
                {{ t('appName') }}
            </span> -->
        </router-link>

        <button
            type="button"
            class="inline-flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-slate-200 focus:outline-hidden"
            @click="menuOpen = true"
        >
            <span class="sr-only">Open sidebar</span>
            <MdiMenu
                class="h-6 w-6"
                aria-hidden="true"
            />
        </button>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="z-[5700] hidden select-none lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex min-h-0 flex-1 flex-col bg-slate-700">
            <div
                id="msnd"
                class="flex flex-1 flex-col overflow-y-auto pb-4"
            >
                <router-link
                    :to="{ name: 'dashboard' }"
                    class="flex h-32 shrink-0 items-center justify-center bg-slate-900 px-1"
                >
                    <div>
                        <BrandLogo css-class="w-40" />
                        <!-- <span
                            class="text-slate-200 text-base font-bold uppercase tracking-wide"
                        >
                            {{ t('appName') }}
                        </span> -->
                    </div>
                </router-link>
                <nav
                    v-if="loggedUser.id !== '0' && route.name !== 'login'"
                    class="flex-1 p-0"
                    aria-label="nav"
                    aria-labelledby="msnd"
                >
                    <router-link
                        v-for="item in navigation.main"
                        :key="item.name"
                        :to="{
                            name: item.name,
                            params: item.params || {},
                            query: item.q || {},
                        }"
                        :class="[
                            currentRouteMatch(item.matchRoutes, route.name)
                                ? 'bg-slate-800 text-slate-200'
                                : 'text-slate-300 hover:bg-slate-800 hover:text-slate-200',
                            'flex items-center gap-2 p-3 text-sm font-semibold transition-colors',
                        ]"
                    >
                        <component
                            :is="item.icon"
                            class="-mt-1 inline h-5 w-5"
                            aria-hidden="true"
                        />
                        <div class="text-sm">
                            {{ item.title }}
                        </div>
                    </router-link>
                </nav>
            </div>

            <div
                v-if="loggedUser.id !== '0'"
                class="flex shrink-0 flex-col bg-slate-900 p-0"
            >
                <router-link
                    v-for="item in navigation.user"
                    :key="item.name"
                    :to="{
                        name: item.name,
                        params: item.params || {},
                        query: item.q || {},
                    }"
                    :class="[
                        currentRouteMatch(item.matchRoutes, route.name)
                            ? 'bg-black text-slate-100'
                            : 'text-slate-200 hover:bg-black hover:text-slate-100',
                        'flex items-center p-3 text-sm font-semibold transition-colors',
                    ]"
                >
                    <component
                        :is="item.icon"
                        class="h-5 w-5 shrink-0"
                        aria-hidden="true"
                    />
                    <div class="ml-3 text-sm font-medium">
                        {{ item.title }}
                    </div>
                </router-link>
                <button
                    class="group block w-full shrink-0 cursor-pointer"
                    @click="logoutSession()"
                >
                    <div
                        class="flex items-center p-3 text-amber-400 transition-colors group-hover:bg-black group-hover:text-amber-200"
                    >
                        <MdiLogout
                            class="block h-5 w-5"
                            aria-hidden="true"
                        />
                        <div class="ml-3 text-sm font-medium">
                            {{ t('Logout') }}
                        </div>
                    </div>
                </button>
                <div class="flex h-8 items-end justify-center pb-2 select-text">
                    <BuildBadge />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { currentRouteMatch } from '../composables/navs';
import { getLoggedUser, logout } from '../composables/useLogin';
import BrandLogo from './BrandLogo.vue';
import BuildBadge from '../ui/BuildBadge.vue';
import { t } from '../composables/i18n';
import { notify } from 'notiwind';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import {
    MdiAccount,
    MdiClose,
    MdiMenu,
    MdiLogout,
    MdiApplicationCog,
    MdiAccountGroup,
    MdiHome,
    MdiFileDocumentEdit,
    MdiVariable,
    MdiListStatus,
    MdiFolderEdit,
    MdiTag,
} from 'materialdesignicons-vue3/icons/';

defineExpose({
    name: 'NavMain',
});

const config = inject('config');

const loggedUser = getLoggedUser(),
    menuOpen = ref(false),
    route = useRoute(),
    router = useRouter();

const navigation = {
    main: [
        {
            title: t('Dashboard'),
            name: 'dashboard',
            href: '/',
            icon: MdiHome,
            matchRoutes: ['dashboard'],
        },
        {
            title: t('Templates'),
            name: 'templates',
            href: '/templates',
            icon: MdiFileDocumentEdit,
            matchRoutes: ['templates', 'template', 'template-versions', 'template-version-edit'],
            params: {
                page: 1,
            },
            /* q: {
                search: 'OLI_',
                tags: ['dev', 'test'],
            }, */
        },
        {
            title: t('Placeholders'),
            name: 'placeholders',
            href: '/placeholders',
            icon: MdiVariable,
            matchRoutes: ['placeholders', 'placeholder'],
            params: {
                page: 1,
            },
        },
        {
            title: t('BatchImport'),
            name: 'batch-import-1',
            href: '/batch-import-1',
            icon: MdiListStatus,
            matchRoutes: ['batch-import-1', 'batch-import-2', 'batch-import-3', 'batch-import-4'],
            params: {
                page: 1,
            },
        },
        {
            title: t('Files'),
            name: 'files',
            href: '/files',
            icon: MdiFolderEdit,
            matchRoutes: ['files', 'file'],
        },
        {
            title: t('Tags'),
            name: 'tags',
            href: '/tags',
            icon: MdiTag,
            matchRoutes: ['tags', 'tag'],
            params: {
                page: 1,
            },
        },
        /* {
            title: t('Snippets'),
            name: 'snippets',
            href: '/snippets',
            icon: MdiFileDocumentEdit,
            matchRoutes: ['snippets', 'snippet'],
        }, */
        {
            title: t('Users'),
            name: 'users',
            href: '/users',
            icon: MdiAccountGroup,
            matchRoutes: ['users', 'profile'],
            params: {
                page: 1,
            },
        },
    ],
    user: [
        {
            title: t('MyProfile'),
            name: 'profile',
            href: `/profile`,
            params: {
                userid: loggedUser.id,
            },
            icon: MdiAccount,
            matchRoutes: ['profile'],
        },
        {
            title: t('Settings'),
            name: 'settings',
            href: '/settings',
            icon: MdiApplicationCog,
            matchRoutes: ['settings'],
            q: {
                mode: 'user',
            },
        },
    ],
};

const logoutSession = async () => {
    const lg = await logout(config);
    if (lg !== false) {
        router.push('/login');
    } else {
        notify(
            {
                group: 'error',
                title: 'Error',
                text: 'Logout error., see console for more information',
            },
            5000,
        );
    }
};
</script>
